import { useTranslation } from 'react-i18next';
import classes from './WhyChoose.module.scss';

const list = [
    'portfolio.why-choose.li_01',
    'portfolio.why-choose.li_02',
    'portfolio.why-choose.li_03',
    'portfolio.why-choose.li_04',
    'portfolio.why-choose.li_05',
];

const WhyChoose = () => {
    const { t } = useTranslation();
    return (
        <section className="mt container">
            <div className={classes.wrap}>
                <div className={`${classes.col} ${classes.col_01}`}>
                    <h2 className={`${classes.title} font-48`}>
                        {t('portfolio.why-choose.title')}
                    </h2>
                    <ul className={`${classes.list} font-16`}>
                        {list.map((li, index) =>
                            <li key={index}>
                                {t(li)}
                            </li>
                        )}
                    </ul>
                </div>
                <div className={`${classes.col} ${classes.col_02}`}>
                    <h2 className={`${classes.title} font-48`}>
                        {t('portfolio.story.title')}
                    </h2>
                    <div className={classes.content}>
                        <p className={`${classes.text} font-16`}>
                            {t('portfolio.story.text_01')}
                        </p>
                        <div className={classes.contact}>
                            <p className="font-20">
                                {t('portfolio.story.text_02')}
                            </p>
                            <a href="tel:+971523252486" className="font-20">
                                +971 52 325 2486
                            </a>
                            <p className="font-20">
                                {t('portfolio.story.text_03')}
                            </p>
                        </div>
                        <p className={`${classes.text} font-16`}>
                            {t('portfolio.story.text_04')}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhyChoose;
